import i18next from 'i18next';
import { FuseNavItemType } from '@fuse/core/FuseNavigation/types/FuseNavItemType';

import en from './navigation-i18n/en';
import bg from './navigation-i18n/bg';

i18next.addResourceBundle('en', 'navigation', en);
i18next.addResourceBundle('bg', 'navigation', bg);

/**
 * The navigationConfig object is an array of navigation items for the Fuse application.
 */
const navigationConfig: FuseNavItemType[] = [
	
	{
		id: 'Home',
		title: 'Начало',
		translate: 'HOME',
		type: 'item',
		icon: 'heroicons-outline:home',
		url: 'home',
		auth: ['Godfather', 'Admin', 'Reception', 'Main Cleaner']
	},
	{
		id: 'RoomieAI',
		title: 'ROOMS_ASSIGNMENT',
		translate: 'ROOMS_ASSIGNMENT',
		type: 'item',
		icon: 'material-solid:checklist',
		url: 'roomie-ai',
		auth: ['Godfather', 'Admin', 'Reception', 'Main Cleaner']
	},
	{
		id: 'Clean',
		title: 'Почистване',
		translate: 'CLEAN',
		type: 'item',
		icon: 'material-outline:cleaning_services',
        url: 'clean',
        auth: ['Godfather', 'Cleaner', 'Main Cleaner']
	},
	{
		id: 'CleaningSessions',
		title: 'Cleaning Sessions',
		translate: 'CLEANING_SESSIONS',
		type: 'item',
		icon: 'material-outline:history',
		url: 'cleaning-sessions',
		auth: ['Godfather', 'Admin', 'Reception', 'Main Cleaner']
	},
	
	{
		id: 'Maintenance',
		title: 'Техническа поддръжка',
		translate: 'MAINTENANCE',
		type: 'item',
		icon: 'material-outline:handyman',
		url: 'maintenance',
		auth: ['Godfather', 'Admin', 'Reception', 'Main Cleaner', 'Tech Support']
	},
	{
		id: 'apps.help-center',
		title: 'Help Center',
		type: 'collapse',
		translate: 'HELP_CENTER',
		icon: 'material-outline:help',
		url: '/help-center/home',
		children: [
			{
				id: 'apps.help-center.home',
				title: 'Home',
				translate: 'HOME',
				type: 'item',
				url: '/help-center/home',
				icon: 'heroicons-outline:home',
			},
			// {
			// 	id: 'apps.help-center.faqs',
			// 	title: 'FAQs',
			// 	translate: 'FAQ',
			// 	type: 'item',
			// 	icon: 'material-outline:quiz',
			// 	url: '/help-center/faqs'
			// },
			{
				id: 'apps.help-center.guides',
				title: 'Guides',
				translate: 'GUIDES',
				type: 'item',
				icon: 'heroicons-outline:book-open',
				url: '/help-center/guides'
			},
			// {
			// 	id: 'apps.help-center.support',
			// 	title: 'Support',
			// 	translate: 'SUPPORT',
			// 	type: 'item',
			// 	icon: 'heroicons-outline:envelope',
			// 	url: '/help-center/support'
			// }
		]
	},
	{
		id: 'Settings',
		title: 'Настройки',
		translate: 'SETTINGS',
		type: 'item',
		icon: 'material-outline:settings',
		url: 'settings'
	},

];

export default navigationConfig;
